var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-container" }, [
    _c("div", { staticClass: "login-form" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("p", { staticClass: "login-title" }, [
        _vm._v(_vm._s(_vm.$t("login.welcome"))),
      ]),
      _vm._v(" "),
      !_vm.isSelectRoles
        ? _c(
            "div",
            { staticClass: "login-step" },
            [
              _c(
                "el-form",
                {
                  ref: "loginForm",
                  staticClass: "login-content",
                  attrs: {
                    model: _vm.loginForm,
                    rules: _vm.loginRules,
                    autocomplete: "on",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "username",
                        label: _vm.$t("login.username"),
                      },
                    },
                    [
                      _c("el-input", {
                        ref: "username",
                        attrs: {
                          size: "medium",
                          placeholder: _vm.$t("login.placeholder.username"),
                          name: "username",
                          type: "text",
                          tabindex: "1",
                          autocomplete: "on",
                        },
                        model: {
                          value: _vm.loginForm.username,
                          callback: function ($$v) {
                            _vm.$set(_vm.loginForm, "username", $$v)
                          },
                          expression: "loginForm.username",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "password",
                        label: _vm.$t("login.password"),
                      },
                    },
                    [
                      _c("el-input", {
                        key: _vm.passwordType,
                        ref: "password",
                        attrs: {
                          size: "medium",
                          type: _vm.passwordType,
                          placeholder: _vm.$t("login.placeholder.password"),
                          name: "password",
                          tabindex: "2",
                          autocomplete: "on",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleLogin($event)
                          },
                        },
                        model: {
                          value: _vm.loginForm.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.loginForm, "password", $$v)
                          },
                          expression: "loginForm.password",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "show-pwd", on: { click: _vm.showPwd } },
                        [
                          _c("svg-icon", {
                            attrs: {
                              "icon-class":
                                _vm.passwordType === "password"
                                  ? "eye"
                                  : "eye-open",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.isRemember,
                    callback: function ($$v) {
                      _vm.isRemember = $$v
                    },
                    expression: "isRemember",
                  },
                },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "y" },
                      nativeOn: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.clickRadio($event)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("login.remember")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "login-button",
                  attrs: { loading: _vm.loading, type: "primary" },
                  nativeOn: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.handleLogin($event)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("login.login")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "role-step" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    size: "medium",
                    inline: "",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("login.selectRole") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("login.selectRolePlaceholder"),
                          },
                          model: {
                            value: _vm.role,
                            callback: function ($$v) {
                              _vm.role = $$v
                            },
                            expression: "role",
                          },
                        },
                        _vm._l(_vm.roleList, function (item) {
                          return _c("el-option", {
                            key: item,
                            attrs: {
                              label: _vm.getRoleName(item),
                              value: item,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "role-back-button",
                  nativeOn: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.backToLogin($event)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("login.backToLogin")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "role-login-button",
                  attrs: { type: "primary" },
                  nativeOn: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.changeRole($event)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("login.enterSystem")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-banner" }, [
      _c("img", {
        attrs: { src: require("@/assets/login/logo.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }